function GetHttpResponseError(response) {
    if (response.status === 403) {
        throw new Error('Access Forbidden: You do not have permission to access this resource.');
    }

    if (response.status === 401) {
        throw new Error('Unauthorized: Invalid token or token has expired.');
    }
}

export default GetHttpResponseError;